const routes = [
  {
    path: '',
    component: () => import('@/views/provider/visitRegistry/VisitWrapper.vue'),
    children: [
      {
        path: '/provider/visitRegistry',
        name: 'VisitRegistry',
        component: () =>
          import('@/views/provider/visitRegistry/VisitRegistry.vue'),
      },
      {
        path: '/provider/visitRegistry/validateVisit',
        name: 'VisitRegistryValidate',
        component: () =>
          import('@/views/provider/visitRegistry/VisitValidation.vue'),
      },
    ],
  },
];

export default routes;
